import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { EmailScenario } from "../../bpe/bpe.service";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-email-scenario
                        [scenario]="data.scenario"
                        [eventReference]="data.reference"
                        (saved)="onSaved()"
                        (cancelled)="onCancelled()"
                    ></s25-ng-email-scenario>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEmailScenarioComponent
    extends ModalComponent<{
        scenario: EmailScenario;
        reference?: string;
        onSave?: () => unknown;
        onCancel?: () => unknown;
    }>
    implements OnInit
{
    isInit = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.onSave?.();
        this.data.closeModal();
    }

    onCancelled() {
        this.data.closeModal();
    }
}
